import React from 'react';
import { Calculator, Clock, AlertTriangle } from 'lucide-react';

const MaintenanceSection = ({ 
  formData, 
  handleInputChange, 
  errors
}) => {
  if (!formData.includeMaintenanceCosts) {
    return (
      <div className="mb-6 bg-orange-50 dark:bg-orange-900/20 p-4 rounded-lg border border-orange-200 dark:border-orange-800">
        <label className="flex items-center">
          <input
            type="checkbox"
            name="includeMaintenanceCosts"
            checked={formData.includeMaintenanceCosts}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
            <Calculator className="w-4 h-4 mr-1 text-orange-500" />
            Учитывать расходы на поддержку и обслуживание системы
          </span>
        </label>
        
        <div className="mt-3 flex items-start">
          <AlertTriangle className="w-5 h-5 text-orange-500 flex-shrink-0 mr-2 mt-0.5" />
          <p className="text-xs text-orange-600 dark:text-orange-400">
            Рекомендуется включить расходы на поддержку, так как техническое обслуживание Big Data систем 
            является критически важным для их бесперебойной работы и может составлять 
            до 20% от общей стоимости владения системой ежегодно.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-orange-50 dark:bg-orange-900/20 p-4 rounded-lg border border-orange-200 dark:border-orange-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Calculator className="w-5 h-5 mr-2 text-orange-500" />
        Обслуживание и поддержка системы
      </h3>
      
      <div className="flex items-center mb-4">
        <input
          type="checkbox"
          name="includeMaintenanceCosts"
          checked={formData.includeMaintenanceCosts}
          onChange={handleInputChange}
          className="form-checkbox"
        />
        <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
          Учитывать расходы на обслуживание и поддержку
        </span>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Период обслуживания */}
        <div>
          <label htmlFor="maintenancePeriod" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-orange-500" />
            Период поддержки (месяцев)
          </label>
          <input
            type="text"
            id="maintenancePeriod"
            name="maintenancePeriod"
            value={formData.maintenancePeriod}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.maintenancePeriod ? 'input-error' : ''}`}
            placeholder="Период обслуживания"
          />
          {errors.maintenancePeriod && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.maintenancePeriod}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-orange-100 dark:bg-orange-900/30 p-3 rounded-lg border border-orange-200 dark:border-orange-800">
        <div className="flex items-start">
          <Calculator className="w-5 h-5 text-orange-600 dark:text-orange-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-orange-700 dark:text-orange-300 mb-1">
              Что включает обслуживание системы
            </h4>
            <ul className="list-disc list-inside text-xs text-orange-600 dark:text-orange-400 space-y-1">
              <li>Мониторинг и поддержка работоспособности системы</li>
              <li>Обновление программного обеспечения и библиотек</li>
              <li>Оптимизация производительности и устранение узких мест</li>
              <li>Резервное копирование и восстановление данных</li>
              <li>Управление доступом и безопасностью</li>
              <li>Техническая поддержка пользователей</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceSection;